import React from 'react'
import RightSide from '../components/common/rightSide';
import PublicationEthics from '../components/other/publicationEthics';


const PublicationEthicsPage = () => {
    return (
        <>
            <div className='container-fluid mt-2'>
                <div className='row'>
                    {/* <div className='col-md-4'>
                        <RightSide />
                    </div> */}
                    <div className='col-md-12'>
                        <PublicationEthics />
                    </div>

                </div>
            </div>
        </>
    )
}


export default PublicationEthicsPage;